import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Main from "components/UI/Main";
import Icon from "@mui/material/Icon";
import * as yup from "yup";
import MDTypography from "components/MDTypography";
import Avatar from "components/UI/Table/avatar";
import MDSnackbar from "components/MDSnackbar";
import UpdateRecord from "helpers/compare";
import Page from "components/UI/Page";
import { Grid } from "@mui/material";
import DataModal from "components/UI/DataModal";
import PagesCount from "helpers/pages-count";
import ProductTags from "./ProductTags";
import {
  addComplexDataAction,
  fetchDataAction,
  deleteDataAction,
  reset,
} from "../../../../store/features/coreSlice";
import dataVal from "../dataVal.json";

const Tags = () => {
  const dispatch = useDispatch();

  const { tagsMainMeta, tagsMain, resStatus, limit } = useSelector((state) => state.core);

  const [open, setOpen] = useState(false);
  const [tagId, setTagId] = useState(null);
  const [newArr, setNewArr] = useState([]);
  const [data, setData] = useState([]);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(false);
  const [initialValues, setInitialValues] = useState(dataVal.initialValues);
  const [successSB, setSuccessSB] = useState(false);
  const [pageNum, setPageNum] = useState(1);
  const [pageOptions, setPageOption] = useState([]);

  const closeSuccessSB = () => setSuccessSB(false);

  const orgData = () => {
    setData([
      {
        type: "TextField",
        name: "arabic_title",
        id: "arabic_title",
        label: "arabic_title",
        size: 4,
        title: "Arabic Title",
      },
      {
        type: "TextField",
        name: "english_title",
        id: "english_title",
        label: "english_title",
        size: 4,
        title: "English Title",
      },
      {
        type: "TextField",
        name: "sequence",
        id: "sequence",
        label: "sequence",
        size: 4,
        title: "Sequence",
      },
      {
        type: "TextArea",
        name: "arabic_description",
        id: "arabic_description",
        label: "arabic_description",
        maxRows: 4,
        minRows: 4,
        size: 4,
        title: "Arabic Description",
      },
      {
        type: "TextArea",
        name: "english_description",
        id: "english_description",
        label: "english_description",
        maxRows: 4,
        minRows: 4,
        size: 4,
        title: "English Description",
      },
      {
        type: "Img",
        name: "tag_image",
        id: "tag_image",
        label: "tag_image",
        size: 4,
        title: "Image",
      },
    ]);
  };

  const onUpdateHandler = (name, values) => {
    setInitialValues({
      id: values.id,
      english_title: values.english_title,
      arabic_title: name === "reset" ? null : values.arabic_title,
      english_description: values.english_description,
      arabic_description: values.arabic_description,
      tag_image: values.tag_image?.data.full_url,
      sequence: values.sequence,
    });
  };

  const resetForm = () => {
    console.log("resetForm");
    setInitialValues(dataVal.initialValues);
    orgData();
  };

  const onDeleteHandler = (name, values) => {
    setOpenDeleteModal(true);
    setDeleteItemId(values.id);
  };

  const getData = () => {
    // get product data
    const url = `items/tags?fields=status,id,products.product_id.status,arabic_title,english_title,arabic_description,english_description,background_color,sequence,parent_tag.english_title,parent_tag.id,tag_image.id&meta=*&limit=${limit}&page=${pageNum}`;
    dispatch(
      fetchDataAction({
        url,
        varName: "tagsMain",
      })
    );
  };

  const changeStatus = (status, category) => {
    const req = {
      id: category.id,
      origin: {
        data: { status },
        table: "tags",
      },
      getInfo: {
        url: `items/tags?fields=status,id,products.product_id.status,arabic_title,english_title,arabic_description,english_description,background_color,sequence,parent_tag.english_title,parent_tag.id,tag_image.id&meta=*&limit=${limit}&page=${pageNum}`,
        varName: "tagsMain",
      },
    };
    dispatch(addComplexDataAction(req));
  };

  const prepareTableRows = () => {
    let item = {};
    const Arr = [];
    let keys = [];
    const d = [];
    for (let i = 0; i < PagesCount(+tagsMainMeta.filter_count, limit); i += 1) {
      d.push(i);
    }
    setPageOption(d);
    tagsMain.forEach((tag) => {
      item = {};
      keys = Object.keys(tag);

      item.title = (
        <Avatar dir="ltr" image={tag.tag_image?.data?.full_url} name={tag.arabic_title} email="" />
      );

      keys.forEach((element) => {
        item[element] = tag[element];
      });

      item.action = (
        <>
          <MDTypography
            style={{ padding: 20, color: "#3b94ee" }}
            component="a"
            href="#"
            variant="caption"
            color="text"
            fontWeight="medium"
            onClick={() => onUpdateHandler("tagsMain", tag)}
          >
            <Icon fontSize="small">edit</Icon>
          </MDTypography>
          <MDTypography
            style={{ padding: 20, color: "#e9423f" }}
            component="a"
            href="#"
            variant="caption"
            color="text"
            fontWeight="medium"
            onClick={() => onDeleteHandler("tagsMain", tag)}
          >
            <Icon fontSize="small">delete</Icon>
          </MDTypography>
          <MDTypography
            style={{ padding: 20, color: "green" }}
            component="a"
            href="#"
            variant="caption"
            color="text"
            fontWeight="medium"
            onClick={() => {
              setTagId(tag.id);
              setOpen(!open);
            }}
          >
            <Icon fontSize="small">sort</Icon>
          </MDTypography>
          {tag.status === "draft" ? (
            <MDTypography
              className="button-group"
              style={{ padding: 20, color: "#e9423f" }}
              component="a"
              href="#"
              variant="caption"
              color="text"
              fontWeight="medium"
              onClick={() => changeStatus("published", tag)}
            >
              <Icon fontSize="small">public_off</Icon>
            </MDTypography>
          ) : (
            <MDTypography
              style={{ padding: 20, color: "green" }}
              component="a"
              href="#"
              variant="caption"
              color="text"
              fontWeight="medium"
              onClick={() => changeStatus("draft", tag)}
            >
              <Icon fontSize="small">public</Icon>
            </MDTypography>
          )}
        </>
      );
      Arr.push(item);
    });
    setNewArr(Arr);
  };

  const setPageNumber = (num) => {
    if (num) {
      setPageNum(num);
      const url = `items/tags?fields=status,id,products.product_id.status,arabic_title,english_title,arabic_description,english_description,background_color,sequence,parent_tag.english_title,parent_tag.id,tag_image.id&meta=*&limit=${limit}&page=${num}`;

      dispatch(
        fetchDataAction({
          url,
          varName: "tagsMain",
        })
      );
    }
  };

  const setPayload = (values) => {
    const payloadData = {};
    const lastData = values.id ? UpdateRecord(values, initialValues) : values;

    Object.keys(lastData).forEach((key) => {
      if (lastData[key] && typeof lastData[key] === "object") payloadData[key] = lastData[key].id;
      else if (values.id || lastData[key]) payloadData[key] = lastData[key];
    });

    const req = {
      imgFieldName: "tag_image",
      id: values.id,
      file: typeof values.tag_image === "object" ? values.tag_image : null,
      origin: {
        data: Object.keys(payloadData).length === 0 ? null : payloadData,
        table: "tagsMain",
      },
      getInfo: {
        url: `items/tags?fields=status,id,products.product_id.status,arabic_title,english_title,arabic_description,english_description,background_color,sequence,parent_tag.english_title,parent_tag.id,tag_image.id&meta=*&limit=${limit}&page=${pageNum}`,
        varName: "tagsMain",
      },
    };
    dispatch(addComplexDataAction(req));
  };

  const handleConfirmDelete = async () => {
    const payload = {
      url: "items/tags",
      data: {
        id: deleteItemId,
        status: "deleted",
      },
      getInfo: {
        url: `items/tags?fields=status,id,products.product_id.status,arabic_title,english_title,arabic_description,english_description,background_color,sequence,parent_tag.english_title,parent_tag.id,tag_image.id&meta=*&limit=${limit}&page=${pageNum}`,
        varName: "tagsMain",
      },
    };
    dispatch(deleteDataAction(payload));
    setOpenDeleteModal(false);
  };

  const renderSuccessSB = (
    <MDSnackbar
      color="success"
      icon="check"
      title="Diwan Dashboard"
      content="successful process"
      dateTime="recently"
      open={successSB}
      onClose={closeSuccessSB}
      close={closeSuccessSB}
      bgWhite
    />
  );

  useEffect(() => {
    if (resStatus && resStatus === "success") {
      setSuccessSB(true);
      resetForm();
    }
  }, [resStatus]);

  useEffect(
    () => () => {
      dispatch(reset(null));
    },
    []
  );

  useEffect(() => {
    getData();
  }, [limit]);

  useEffect(() => {
    if (tagsMain && tagsMain.length !== 0) {
      prepareTableRows();
    }
  }, [tagsMain]);

  useEffect(() => {
    orgData();
  }, []);

  if (data.length === 0 || newArr === [] || !tagsMainMeta) {
    return null;
  }

  return (
    <Page>
      <Grid item xs={12}>
        <DataModal
          handleClose={() => {
            setOpen(!open);
            dispatch(reset(null));
            console.log("object object object");
          }}
          open={open}
        >
          {tagId && <ProductTags tagId={tagId} />}
        </DataModal>
        <Main
          layout="simple"
          allRowsCount={+tagsMainMeta.filter_count}
          pageIndex={pageNum - 1}
          count={pageOptions}
          setPageNum={setPageNumber}
          setOpenDeleteModal={setOpenDeleteModal}
          openDeleteModal={openDeleteModal}
          handleConfirmDelete={handleConfirmDelete}
          name="tagsMain"
          setPayload={setPayload}
          data={data}
          initialValues={initialValues}
          title="Add Library Categories"
          columns={dataVal.columns}
          rows={newArr}
          onUpdateHandler={onUpdateHandler}
          onDeleteHandler={onDeleteHandler}
          entriesPerPage
          yupObj={{
            arabic_title: yup.string("Enter your Title").required("Title is required").nullable(),
          }}
        />
        {renderSuccessSB}
      </Grid>
    </Page>
  );
};

export default Tags;
